import { createPortal } from "react-dom";
import { useTabActive } from "../../lib/tabActive";
import "./ProcessingOverlay.css";

/** Tam ekran bloke eden işlem katmanı (uzun kayıt/işlem için). Kurumsal indeterminate progress bar. */
export function ProcessingOverlay({ open, title, message }: { open: boolean; title?: string; message?: string }) {
  const tabActive = useTabActive();
  if (!open) return null;
  // PASİF SEKMEDE DOM'A BASILMAZ. Portal `document.body`ye gider, yani sekme panelinin
  // `display:none` gizlemesi bu katmana ULAŞMAZ — gizli sekmenin paneli aktif sayfanın
  // üstünde durmaya devam ederdi. Burada `null` dönmek DOM'u düşürür, katmanı açan durum
  // (hangi kayıt, forma ne yazıldı) sayfanın React state'inde YAŞAMAYA DEVAM eder.
  if (!tabActive) return null;

  return createPortal(
    <div className="proc-overlay" role="alertdialog" aria-busy="true" aria-live="assertive" aria-label={title ?? "İşlem yapılıyor"}>
      <div className="proc-card">
        <div className="proc-head">
          <span className="proc-dot" aria-hidden="true" />
          <span className="proc-title">{title ?? "İşlem yapılıyor"}</span>
        </div>
        {message ? <div className="proc-sub">{message}</div> : null}
        <div className="proc-bar" aria-hidden="true"><span /></div>
      </div>
    </div>,
    document.body,
  );
}
